import { useCallback, useState } from 'react'

import { useDataObject } from '@hooks/useDataObject'

type Errors<T> = { [key in keyof T]?: string | null }
type FormHook<T> = {
  data: T
  updateData: (data: Partial<T>) => void
  errors: Errors<T>
  setError: (error: Partial<Errors<T>>) => void
  clearError: (key: keyof T) => void
  clearErrors: () => void
}

export default function useForm<T>(initialData: T): FormHook<T> {
  const [data, updateData] = useDataObject<T>(initialData)
  const [errors, setErrors] = useState<Errors<T>>({})

  const setError = useCallback((error) => {
    setErrors((oldErrors) => ({ ...oldErrors, ...error }))
  }, [])

  const clearErrors = useCallback(() => setErrors({}), [])

  const clearError = useCallback((key: keyof T) => {
    setErrors((prevErrors) => ({ ...prevErrors, [key]: null }))
  }, [])

  return { data, updateData, errors, setError, clearErrors, clearError }
}
